import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-modal-report',
  templateUrl: './modal-report.component.html',
  standalone: false,
})
export class ModalReportComponent {
  public groups$: Observable<any>;
  constructor(@Inject(DIALOG_DATA) public data: Observable<any>) {}
}
